export enum RegionType {
  DRIVE_TIME = 'DRIVE_TIME',
  MARKET_AREA = 'MARKET_AREA',
  RING = 'RING',
  TRADE_AREA = 'TRADE_AREA'
}
